exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".types{margin:0 auto;text-align:center;display:table}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-document-aggregator.vue"],"names":[],"mappings":"AACA,OACE,cAAe,AACf,kBAAmB,AACnB,aAAe,CAChB","file":"vuetify-document-aggregator.vue","sourcesContent":["\n.types {\n  margin: 0 auto;\n  text-align: center;\n  display: table;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d70f3c32","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vuetify-document-aggregator.vue
// module id = 687
// module chunks = 0 1 2